<template>
  <input
    type="range"
    :min="sliderMin"
    :max="sliderMax"
    :step="sliderStep"
    :value="sliderValue"
    @input="handleInput($event)"
  />
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';

  const props = defineProps<{
    sliderValue: number;
    sliderMin: number;
    sliderMax: number;
    sliderStep: number;
  }>();
  const {
    sliderValue,
    sliderMin,
    sliderMax,
    sliderStep
  } = toRefs(props);

  const emit = defineEmits<{
    (e: 'update:sliderValue', sliderValue: number): void;
  }>();

  function handleInput(e: Event) {
    if (!(e.target instanceof HTMLInputElement)) {
      return;
    }

    emit('update:sliderValue', Number(e.target.value));
  }
</script>

<style scoped>
  input {
    height: 30px;
    margin: 0px;
    vertical-align: middle;
  }
</style>
